export default __webpack_public_path__ + "images/cn-7977e12a9afade492c93c76be2cb47de.svg";